import { useEffect } from "react";
import { Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { Header } from "../../../components/Landing/Header/haeder.view";
import apiJurados from "../../../api/Jurados/api-jurados";
import { useEducacionFormal } from "../../../hooks/useEducacionFormal";
import { RootState } from "../../../redux/reducers";
import { BannerJurados } from "../components/BannerJurados";
import { TextoInicialJurados } from "../components/TextoInicialJurados";
import { FormEducacionFormal } from "./components/form-educacionformal.view";
import { TableEducacionFormal } from "./components/table-educacionformal.view";
import { juradoEditar, menuJuradoAction } from "../../../redux/actions/juradosAction";
import "./educacion-formal.style.scss";
import { Footer } from "../../../components/Landing/Footer";
import { openNotification } from "../../../utils/Notifactions";
import { UseVerConvocatorias } from "../../../hooks/UseVerConvocatorias";

export const EduacionFormal = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { educacion, menuJurado } = useSelector((state: RootState) => state.jurado);
  const { estadoFormulario } = useParams();
  const idJurado = localStorage.getItem("idJurado");
  const {
    getConvocatoriaPersistente,
    convocatoriaPersitente: convocatoria,
  } = UseVerConvocatorias();
  const {
    educacionFormal,
    guardarFormulario,
    setEducacionFormal,
    guardarArchivo,
    formRef,
    resetForm,
    educacionFormalArray,
    setEducacionFormalArray,
    isGraduado,
    handleGraduacion,
  } = useEducacionFormal();

  useEffect(() => {
    cargarEducacionFormal();
    getConvocatoriaPersistente();
  }, []);

  const cargarEducacionFormal = async () => {
    const educacion_formal = await apiJurados.obtenerEducacionFormal(idJurado);

    if (educacion_formal !== undefined) {
      return setEducacionFormalArray(educacion_formal);
    }
  };


  const nextScreen = async () => {
    if (educacionFormalArray.length === 0) {
      return openNotification({
        titulo: "Error",
        descripcion: "Debe enviar al menos una educación formal",
        placement: "bottomRight",
      });
    }
    try {
      await apiJurados.putEducacionFormal(educacionFormalArray, idJurado);
      if (estadoFormulario !== "" && estadoFormulario !== undefined) {
        dispatch(juradoEditar(false));
        return navigate("/usuario/estadosFormulario");
      }
      if (menuJurado) {
        dispatch(menuJuradoAction(false));
        return navigate("/usuario/MenuJurado");
      }
      if (educacion === 1) {
        return navigate("/usuario/agregarExperienciaProfesionalJurado");
      }
      return navigate("/usuario/educacionNoFormal");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Header />
      <BannerJurados BannerText="Banco de Jurados - Mi Educación Formal" convocatorias={convocatoria}/>
      <div className="container-fluid2">
        <div className="row">
          <TextoInicialJurados
            TituloSpan="Agrega tu educación formal."
            TitulosinSpan="Puedes agregar varios títulos de educación formal."
          />
        </div>
        <div className="row">
          <div className="col-12">
            <div className="row mt-4 g-1 pe-0">
              <div className="col-1 ms-1 me-0 d-flex justify-content-center align-content-center font-family-Montserrat-Regular font-size-18px numero-seleccionar-postulacion numero-jurados">
                3
              </div>
              <h2 className="col ps-0 ms-0 font-family-Montserrat-Regular font-size-18px titulo-numero-postulacion">
                Agregar educación formal
              </h2>
            </div>
          </div>
          <div className="col-12">
            <FormEducacionFormal
              educacionFormal={educacionFormal}
              guardarFormulario={guardarFormulario}
              setEducacionFormal={setEducacionFormal}
              guardarArchivo={guardarArchivo}
              formRef={formRef}
              resetForm={resetForm}
              isGraduado={isGraduado}
              handleGraduacion={handleGraduacion}
            />
          </div>
          <div className="col-12">
            <TableEducacionFormal
              eduacionFormalArray={educacionFormalArray}
              setEduacionFormalArray={setEducacionFormalArray}
            />
          </div>
          <nav
            className="col bg-white"
            style={{
              justifyContent: "center",
              position: "sticky",
              bottom: 0,
              paddingBottom: "0%",
              zIndex: 1000,
            }}
          >
            <div className="justify-content-end">
              <div className="col justify-content-flex-end">
                <Button className="button-blanco-radius" onClick={() => { return navigate('/usuario/categorias') }}>
                  Atrás
                </Button>
                <Button className="button-azul-radius" onClick={nextScreen}>
                  Continuar
                </Button>
              </div>
            </div>
          </nav>
        </div>
      </div>
      <Footer />
    </>
  );
};
